//------------------------------------------------------------------------------
// 画面設定 型定義
//------------------------------------------------------------------------------
// アクション種別
export default {

  // 地図マウスホイール設定 (ホイールで拡大/縮小)
  WHEEL_ZOOM: 'SETTING/WHEEL_ZOOM',

  // 地図アクション表示設定
  MAP_CONFIG: 'SETTING/MAP_CONFIG',
};
